import { Component } from '@angular/core';

@Component({
	selector: 'seira-previsao-climatica',
	templateUrl: './previsao-climatica.component.html',
	styleUrls: ['./previsao-climatica.component.scss'],
})
export class PrevisaoClimaticaComponent {}
